import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Nillable } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class HttpCacheResponseService {
  private cache = new Map<string, Observable<HttpEvent<unknown>>>();

  public setForRequest(
    request: HttpRequest<unknown>,
    response$: Observable<HttpEvent<unknown>>,
  ): void {
    this.cache.set(this.getCacheKeyBasedOnRequest(request), response$);
  }

  public clearForRequest(request: HttpRequest<unknown>): void {
    this.cache.delete(this.getCacheKeyBasedOnRequest(request));
  }

  public getForRequest(
    request: HttpRequest<unknown>,
  ): Nillable<Observable<HttpEvent<unknown>>> {
    return this.cache.get(this.getCacheKeyBasedOnRequest(request));
  }

  public clear(): void {
    this.cache.clear();
  }

  private getCacheKeyBasedOnRequest(request: HttpRequest<unknown>): string {
    return `[${request.method}] ${request.url}`;
  }
}
